var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-group" },
    [
      _vm.title.length > 0
        ? _c("label", { class: _vm.labelClass, attrs: { for: _vm.id } }, [
            _vm._v(_vm._s(_vm.title) + " "),
            _vm.required
              ? _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
              : _vm._e(),
          ])
        : _vm._e(),
      _vm.type === "checkbox"
        ? _c(
            "input",
            _vm._g(
              _vm._b(
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form[_vm.name],
                      expression: "form[name]",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: {
                    id: _vm.id,
                    placeholder: _vm.placeholder,
                    type: "checkbox",
                  },
                  domProps: {
                    checked: Array.isArray(_vm.form[_vm.name])
                      ? _vm._i(_vm.form[_vm.name], null) > -1
                      : _vm.form[_vm.name],
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.form[_vm.name],
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(_vm.form, _vm.name, $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.form,
                              _vm.name,
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.form, _vm.name, $$c)
                      }
                    },
                  },
                },
                "input",
                _vm.$attrs,
                false
              ),
              _vm.$listeners
            )
          )
        : _vm.type === "radio"
        ? _c(
            "input",
            _vm._g(
              _vm._b(
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form[_vm.name],
                      expression: "form[name]",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: {
                    id: _vm.id,
                    placeholder: _vm.placeholder,
                    type: "radio",
                  },
                  domProps: { checked: _vm._q(_vm.form[_vm.name], null) },
                  on: {
                    change: function ($event) {
                      return _vm.$set(_vm.form, _vm.name, null)
                    },
                  },
                },
                "input",
                _vm.$attrs,
                false
              ),
              _vm.$listeners
            )
          )
        : _c(
            "input",
            _vm._g(
              _vm._b(
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form[_vm.name],
                      expression: "form[name]",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: {
                    id: _vm.id,
                    placeholder: _vm.placeholder,
                    type: _vm.type,
                  },
                  domProps: { value: _vm.form[_vm.name] },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.form, _vm.name, $event.target.value)
                    },
                  },
                },
                "input",
                _vm.$attrs,
                false
              ),
              _vm.$listeners
            )
          ),
      _c("suc-field-has-error", { attrs: { form: _vm.form, field: _vm.name } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }